(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-modal hq-lighting-modal--base"><button hq-tools-lighting-focus-on="modal-close" ng-click="$ctrl.closeModal()" class="hq-lighting-modal__close">{{\'CLOSE_INFORMATION\' | translate}}</button><div class="hq-lighting-modal__content"><p>{{\'MODAL_BASE\' | translate}}</p><div class="hq-lighting-modal__image-mask"><img ng-src="/themes/mieux-consommer/images/eclairage/item-{{$ctrl.id}}.svg"></div><div class="hq-lighting-modal__image-title">{{$ctrl.id}}</div></div></div>',
    bindings: {
      translateKey: '@',
      id: '@',
      closeModal: '&',
    },
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingModalBase', component);
}());
